module.exports = __webpack_public_path__ + "static/media/gold.71847c0b.svg";